import type {WeightInventoryPlot} from '@/domain/entities/Op';
import type {OpRepository} from '@/domain/interfaces/OpRepository';

export class OpWeightIntentoryPlots {
  constructor(private readonly opRepository: OpRepository) {}
  execute = async (domain: WeightInventoryPlot) => {
    return this.opRepository.weightInventoryPlots(domain);
  };
}
